
const api = { url: "https://api.arverasupport.nl/v1" };

const origin = { url: window.location.origin };

module.exports = { api, origin };
